import { useSelector, useDispatch } from 'react-redux';
import { useLayoutEffect, useEffect } from 'react';

import { getCart, fetchCart, getIsInitial } from './cart';
import { getRecoveredCart, fetchRecoveredCart } from './recovered-cart';

export const useCartWithPrefetch = () => {
    const dispatch = useDispatch();
    const cart = useSelector(getCart);
    const recoveredCart = useSelector(getRecoveredCart);
    const isInitial = useSelector(getIsInitial);

    useLayoutEffect(() => {
        if (isInitial) {
            dispatch(fetchCart());
        }
    }, []);

    useEffect(() => {
        dispatch(fetchRecoveredCart());
    }, [cart]);

    return { cart, recoveredCart };
};
